'use client'

import { useEffect } from "react"
import { useSession, signOut } from "next-auth/react"
import { usePathname } from "next/navigation"
import Image from "next/image"
import Logo from "@/assets/favicon.png"

export default function RefreshVendor({ vendorId }: { vendorId: string }) {
  const { data: session, update } = useSession()
  const pathname = usePathname()

  useEffect(() => {
    handleSignOut()
  }, [vendorId, session, update])

  const handleSignOut = async () => {
    if (session && session.user && session.user.vendorId !== vendorId) {
      await signOut({ redirect: false })
      update({
        ...session,
        user: {
          vendorId: vendorId,
        },
      })
      window.location.href = `${window.location.origin}${pathname}`
    }
  }

  return (
    <div className="cont flex flex-col items-center justify-center h-screen">
      <div className="mb-4">
        <Image src={Logo} alt="Logo" width={80} height={80} className="w-20 h-20 object-cover animate-pulse" />
      </div>
      <h1 className="font-medium text-foreground">Уншиж байна...</h1>
    </div>
  )
}